import { FC, MouseEvent, useState } from 'react';
import Menu from '@mui/material/Menu';
import { homeUrl, logoutCallbackUrl } from '@utils/UrlBuilder';
import MenuItem from '@mui/material/MenuItem';
import { Link, useHistory } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { NavigationItemType } from '@interfacetypes/index';
import './_navigationItem.scss';
import { useTheme } from '@mui/material';

interface NavigationItemProps {
  navigation: NavigationItemType;
  handleCloseParentNavMenu?: (page?: NavigationItemType | undefined, close?: boolean) => void;
  isMobile?: boolean;
}

const NavigationItem: FC<NavigationItemProps> = ({ navigation, handleCloseParentNavMenu, isMobile }): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [show, setShow] = useState(false);
  const theme = useTheme();
  const { logout } = useAuth0();
  const history = useHistory();

  const handleMenu = (event: MouseEvent<HTMLElement>) => {
    if (navigation.route) {
      history.push(navigation.route);
      return;
    }
    if (navigation.menu) {
      setAnchorEl(event.currentTarget);
      setShow(true);
    }
  };

  const handleCloseNavMenu = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    if (event.currentTarget.id === 'logout') {
      logout({ returnTo: logoutCallbackUrl() });
    }
    setAnchorEl(null);

    // close parent menu before unmounting submenu
    if (handleCloseParentNavMenu) handleCloseParentNavMenu(navigation, true);
    setShow(false);
  };

  return (
    <div id="navigationItemWrapper" key={navigation.name} className="navigationItemWrapper" onClick={handleMenu}>
      <span className="navigationItemContent">
        {navigation.leftIcon && (
          <span className="navigationLeftIcon" style={{ color: theme.palette.common.black }}>
            {navigation.leftIcon}
          </span>
        )}
        <span className="navigationName" style={{ color: isMobile ? theme.palette.common.black : theme.palette.common.white }}>
          {navigation.name}
        </span>
        {navigation.rightIcon && <span className="navigationRightIcon">{navigation.rightIcon}</span>}
        {navigation.menu && (
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            open={show}
            onClose={handleCloseNavMenu}
          >
            {navigation.menu.map((menuItem: NavigationItemType) => {
              return (
                <MenuItem key={menuItem.key}>
                  <Link
                    id={menuItem.key}
                    to={menuItem.route || homeUrl()}
                    onClick={handleCloseNavMenu}
                    className="navigationLink"
                    style={{ color: theme.palette.common.black }}
                  >
                    {menuItem.name}
                  </Link>
                </MenuItem>
              );
            })}
          </Menu>
        )}
      </span>
    </div>
  );
};

NavigationItem.defaultProps = {
  handleCloseParentNavMenu: undefined,
};

export default NavigationItem;
